import { useContext } from "react";
import { Context } from "./authContext";

const useAuthContext = () => useContext(Context);

export default useAuthContext;
